import { REGISTER_FIREBASE_APP } from 'common/actions/firebase'

const initialState = {
  firebaseApp: undefined
}

export const firebaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_FIREBASE_APP:
      return {
        ...state,
        firebaseApp: action.firebaseApp
      }
    default:
      return state
  }
}

export default firebaseReducer
